import { create } from "zustand"
import { guardarPreferencias, leerPreferencias, type Tema } from "./tema"

export type TipoUsuario = "INTERNO" | "CLIENTE" | "TRANSPORTISTA"

export interface UsuarioSesion {
  id: number
  email: string
  nombre: string
  tipo: TipoUsuario
  cliente_id: number | null
  roles: string[]
  permisos: string[]
}

export type Densidad = "compacta" | "comoda"

interface EstadoSesion {
  usuario: UsuarioSesion | null
  cargando: boolean
  tema: Tema
  /** Cuánto se oscurecen las fotografías, de 0 a `VELO_MAXIMO`. Sólo en oscuro. */
  veloFotos: number
  densidad: Densidad
  setTema: (t: Tema) => void
  setVeloFotos: (v: number) => void
  setUsuario: (u: UsuarioSesion | null) => void
  setCargando: (v: boolean) => void
  setDensidad: (d: Densidad) => void
}

/**
 * Zustand guarda EXACTAMENTE tres cosas: sesión, tema y densidad de tabla. El
 * velo de las fotografías es parte del tema: es cómo se ve el fondo oscuro.
 *
 * Todo lo demás —expedientes, tareas, documentos, mensajes— es estado de
 * servidor y vive en TanStack Query. Copiar una respuesta aquí crearía una
 * segunda copia que se desincroniza en cuanto alguien mute algo en otra
 * pestaña, y entonces nadie sabe cuál de las dos es la buena.
 */
const preferencias = leerPreferencias()

export const usarSesion = create<EstadoSesion>((set, get) => ({
  usuario: null,
  cargando: true,
  /**
   * ⚠ **`oscuro` es el de las fotografías, y es el predeterminado.** `claro` quita
   * las fotos y pone el armazón entero en superficies claras. Lo aplica `AppShell`,
   * sólo con sesión: el acceso es oscuro sobre la foto en cualquier caso.
   */
  tema: preferencias.tema,
  veloFotos: preferencias.velo,
  densidad: "compacta",
  setTema: (tema) => {
    guardarPreferencias(tema, get().veloFotos)
    set({ tema })
  },
  setVeloFotos: (veloFotos) => {
    guardarPreferencias(get().tema, veloFotos)
    set({ veloFotos })
  },
  setUsuario: (usuario) => set({ usuario, cargando: false }),
  setCargando: (cargando) => set({ cargando }),
  setDensidad: (densidad) => set({ densidad }),
}))
